import type { FC } from 'react';

import { Button } from '@xing-com/button';

import type { ButtonInternal } from '../../types/types';

type PropsButtonsContainer = {
  buttons: ButtonInternal[];
  className?: string;
  style?: React.CSSProperties;
};
export type Props = React.PropsWithChildren<PropsButtonsContainer>;

export const ButtonsContainer: FC<Props> = ({ buttons, ...props }) => (
  <div {...props}>
    {buttons.map((button, index: number) => (
      <Button {...button} key={index} />
    ))}
  </div>
);
